import React from 'react'
import { Tooltip } from '@material-ui/core'

export const DEVICE_TYPE_COLORS = {
    mobile: { backgroundColor: '#e3f2fd', color: '#1565c0' },
    tablet: { backgroundColor: '#fff3e0', color: '#ef6c00' },
    desktop: { backgroundColor: '#ede7f6', color: '#5e35b1' },
}

export function isAppSession(deviceInfo) {
    return Boolean(deviceInfo?.appVersion) && deviceInfo.appVersion !== 'N/A' && deviceInfo.appVersion !== 'Unknown'
}

export function formatNameList(items) {
    if (!items || items.length === 0) return 'N/A'

    const names = items.map((item) => item?.code || item?.name || '').filter(Boolean)
    if (names.length === 0) return 'N/A'

    const displayNames = names.slice(0, 2)
    const remainingNames = names.slice(2)
    const displayText = displayNames.join(', ')

    if (remainingNames.length === 0) return displayText

    return (
        <span>
            {displayText}
            <Tooltip title={remainingNames.join(', ')}>
                <span style={{ cursor: 'pointer', color: '#1565c0', marginLeft: 5 }}>+{remainingNames.length} more</span>
            </Tooltip>
        </span>
    )
}

export function namesToPlainText(items) {
    if (!items || items.length === 0) return 'N/A'
    const names = items.map((item) => item?.code || item?.name || '').filter(Boolean)
    return names.length ? names.join(', ') : 'N/A'
}

export function formatToIST(isoDate) {
    if (!isoDate) return 'N/A'
    const date = new Date(isoDate)
    return date.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })
}

export function DeviceInfoPopup({ deviceInfo }) {
    if (!deviceInfo) return <div>No device info available</div>

    return (
        <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', padding: '10px', borderRadius: '4px' }}>
            <strong>Device Information</strong><br /><br />
            <div style={{ marginBottom: '5px' }}><strong>Login Source:</strong> {isAppSession(deviceInfo) ? 'Decorpot Care App' : 'Browser'}</div>
            <div style={{ marginBottom: '5px' }}><strong>Device Type/Source:</strong> {deviceInfo?.deviceType || 'desktop'}</div>
            <div style={{ marginBottom: '5px' }}><strong>Device Vendor:</strong> {deviceInfo?.deviceVendor || 'N/A'}</div>
            <div style={{ marginBottom: '5px' }}><strong>Device Model:</strong> {deviceInfo?.deviceModel || 'N/A'}</div>
            <div style={{ marginBottom: '5px' }}><strong>OS:</strong> {deviceInfo?.osName || 'N/A'} {deviceInfo?.osVersion || ''}</div>
            {deviceInfo?.browserName && (
                <div style={{ marginBottom: '5px' }}><strong>Browser:</strong> {deviceInfo?.browserName} {deviceInfo?.browserVersion || ''}</div>
            )}
            {deviceInfo?.appVersion && (
                <div style={{ marginBottom: '5px' }}><strong>App Version:</strong> {deviceInfo?.appVersion}</div>
            )}
            {deviceInfo?.deviceId && (
                <div style={{ marginBottom: '5px' }}><strong>Device ID:</strong> <span style={{ fontSize: '12px', wordBreak: 'break-all' }}>{deviceInfo?.deviceId}</span></div>
            )}
        </div>
    )
}
